import React, { useState, useContext, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { StoreContext } from "../store";
import Image from "react-bootstrap/Image";
import Blog from "./blog";

let LandingSpot = (props) => {
  const { dispatch } = useContext(StoreContext);

  return (
    <div className="catalog-wrapper">
      <h2>Landing Spot</h2>
      <Blog Page="landingspot"></Blog>
    </div>
  );
};

export default LandingSpot;
